import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { DebtorManagement } from '../models/debtorManagement.model';
import { PortfolioManagement } from '../models/portfolioManagement.model';
import { PortfolioState } from '../models/portfolioState.model';
import { CollectionManagementResult } from '../models/collectionManagementResult.model';
import { CollectionManagement } from '../models/collectionManagement.model';
import { SearchPortfolio } from '../models/search-portfolio-model';
import { DocumentSource } from '../models/documentSource.model';

@Injectable({
  providedIn: 'root'
})
export class PortfolioService {


  private Url: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url = baseUrl;
  }


  getActivePortfoliobyUser(idUser: number) {
    let params = new HttpParams().set("IdUser", idUser.toString());
    return this.http.get<DebtorManagement[]>(this.Url + 'api/portfolio/GetActiveByUser', { params: params });
  }

  getActiveByTercero(ccTercero: number) {
    let params = new HttpParams().set("idDebtor", ccTercero.toString());
    return this.http.get<PortfolioManagement[]>(this.Url + 'api/portfolio/GetActiveByDebtor', { params: params });
  }

  getAllByTercero(idDebtor: number) {
    let params = new HttpParams().set("idDebtor", idDebtor.toString());  
    return this.http.get<PortfolioManagement[]>(this.Url + 'api/portfolio/GetAllByDebtor', { params: params });
  }

  getDebtorById(idDebtor: number) {
    let params = new HttpParams().set("idDebtor", idDebtor.toString());
    return this.http.get<DebtorManagement>(this.Url + 'api/portfolio/GetDebtorById', { params: params });
  }

  updateDebtor(debtorData: DebtorManagement) {
    return this.http.patch<DebtorManagement>(this.Url + 'api/portfolio/UpdateDebtor', debtorData);
  }

  //getPhones(idUser: number) {
  //  let params = new HttpParams().set("idUser", idUser.toString());
  //  return this.http.get(this.Url + 'api/portfolio/GetPhones', { params: params });
  //}

  getPortfolioState() {
    return this.http.get<PortfolioState[]>(this.Url + 'api/portfoliostate');
  }

  getCollectionResult() {
    return this.http.get<CollectionManagementResult[]>(this.Url + 'api/collectionstate');
  }

  updatePortfolioState(portfolioManagement: PortfolioManagement) {
    return this.http.patch<PortfolioManagement>(this.Url + 'api/portfolio/UpdatePortfolioState', portfolioManagement);
  }

  saveManagementPortfolio(management: CollectionManagement, allPortfolio: boolean) {
    return this.http.post<CollectionManagement>(this.Url + `api/portfolio/SaveManagementPortfolio?allPortfolio=${allPortfolio}`, management);
  }

  sendPortfolioSearch(search: SearchPortfolio) {
    return this.http.post<SearchPortfolio[]>(this.Url + 'api/portfolio/PostSearchPortfolio', search);
  }

  getDocumentSource() {
    return this.http.get<DocumentSource[]>(this.Url + 'api/portfolio/DocumentSource');
  }
}
